import React from "react";
import { Form, InputGroup, Button, Dropdown, Badge } from "react-bootstrap";
import { IoSearch, IoFilter, IoClose } from "react-icons/io5";

const SearchAndFilter = ({
  searchTerm = "",
  selectedStatus = "ALL",
  selectedType = "ALL",
  selectedRole = "ALL",
  onSearchChange = () => {},
  onSearchSubmit = () => {},
  onStatusChange = () => {},
  onTypeChange = () => {},
  onRoleChange = () => {},
  onClearFilters = () => {},
}) => {
  // Status options
  const statusOptions = [
    { value: "ALL", label: "All Status" },
    { value: "DRAFT", label: "Draft" },
    { value: "PUBLISHED", label: "Published" },
    { value: "ARCHIVED", label: "Archived" },
  ];

  // Type options
  const typeOptions = [
    { value: "ALL", label: "All Types" },
    { value: "TEKNOLOGI", label: "Teknologi" },
    { value: "PENDIDIKAN", label: "Pendidikan" },
    { value: "KESEHATAN", label: "Kesehatan" },
    { value: "BISNIS", label: "Bisnis" },
    { value: "OLAHRAGA", label: "Olahraga" },
    { value: "LAINNYA", label: "Lainnya" },
  ];

  const roleOptions = [
    { value: "ALL", label: "All Roles" },
    { value: "ADMIN", label: "Administrator" },
    { value: "USER", label: "User" },
    { value: "DOCTOR", label: "Doctor" },
  ];

  // Check if any filter is active
  const isFilterActive = selectedStatus !== "ALL" || selectedType !== "ALL";

  return (
    <div className="row g-3 mb-4">
      {/* Search Input */}
      <div className="col-md-6">
        <Form onSubmit={onSearchSubmit}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search artikel by title, content, or type..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <Button variant="primary" type="submit">
              <IoSearch /> Search
            </Button>
          </InputGroup>
        </Form>
      </div>

      <div className="col-md-3">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedRole !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {roleOptions.find((opt) => opt.value === selectedRole)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {roleOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedRole === option.value}
                onClick={() => onRoleChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {isFilterActive && (
        <div className="col-12">
          <div className="d-flex align-items-center gap-2">
            <small className="text-muted">Active filters:</small>
            {selectedStatus !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Status:{" "}
                {
                  statusOptions.find((opt) => opt.value === selectedStatus)
                    ?.label
                }
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onStatusChange("ALL")}
                />
              </Badge>
            )}
            {selectedType !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Type:{" "}
                {typeOptions.find((opt) => opt.value === selectedType)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onTypeChange("ALL")}
                />
              </Badge>
            )}
            {(selectedStatus !== "ALL" || selectedType !== "ALL") && (
              <Button
                variant="link"
                size="sm"
                className="p-0 text-decoration-none"
                onClick={onClearFilters}
              >
                Clear all
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="col-md-1">
        <Button
          variant="outline-secondary"
          className="w-100"
          onClick={onClearFilters}
        >
          <IoClose /> Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default SearchAndFilter;
